// @ts-expect-error -- redux-dynamic-middlewares has no TypeScript declarations.
import reduxDynamicMiddlewares from 'redux-dynamic-middlewares'

import { asyncDataFetchMiddleware } from '@buffer-mono/async-data-fetch'
import { createAuthedRpcCaller } from '@buffer-mono/legacy-rpc-utils'
import type { Middleware } from 'redux'

import {
  redirectToAuthorize,
  redirectToImpersonateStop,
  redirectToOidcLogout,
  refreshAccessToken,
} from '~publish/helpers/oidcAuth'

import segmentTrackingMiddleware from '~publish/legacy/analytics-middleware/middleware'
import bootstrapMiddleware from '~publish/legacy/bootstrap/middleware'
import generalSettingsMiddleware from '~publish/legacy/general-settings/middleware'
import hashtagGroupsMiddleware from '~publish/legacy/hashtag-group-manager/middleware'
import i18nMiddleware from '~publish/legacy/i18n/middleware'
import maintenanceRedirectMiddleware from '~publish/legacy/maintenance-redirect/middleware'
import modalsMiddleware from '~publish/legacy/modals/middleware'
import notificationsProviderMiddleware from '~publish/legacy/notifications-provider/middleware'
import orgMiddleware from '~publish/legacy/organizations/middleware'
import profileNavMiddleware from '~publish/legacy/profile-nav/middleware'
import profileSidebarMiddleware from '~publish/legacy/profile-sidebar/middleware'
import profilesMiddleware from '~publish/legacy/profiles/middleware'
import profilesDisconnectedModalMiddleware from '~publish/legacy/profiles-disconnected-modal/middleware'
import pusherSyncMiddleware from '~publish/legacy/pusher-sync/middleware'

import { rpc } from '../utils/call-rpc/index'

// Adds silent token refresh + single retry to async-data-fetch's RPC traffic,
// matching the explicit callRpc path. Without it, a 401 on those calls fails
// hard instead of recovering.
const authedRpc = createAuthedRpcCaller({
  rpc,
  refreshAccessToken,
  redirectToOidcLogout,
  redirectToImpersonateStop,
  redirectToAuthorize,
})

export const getMiddleware = (): Middleware[] => [
  asyncDataFetchMiddleware(authedRpc),
  i18nMiddleware,
  profileSidebarMiddleware,
  bootstrapMiddleware,
  orgMiddleware,
  profilesMiddleware,
  generalSettingsMiddleware,
  pusherSyncMiddleware,
  modalsMiddleware,
  maintenanceRedirectMiddleware,
  notificationsProviderMiddleware,
  profilesDisconnectedModalMiddleware,
  hashtagGroupsMiddleware,
  segmentTrackingMiddleware,
  profileNavMiddleware,
  // Dynamic middlware insertion point (for lazy-loaded components)
  reduxDynamicMiddlewares,
]
